import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * Example:
 *   about: { it: 'chi-siamo', en: 'about-us' }
 *   → /it/chi-siamo, /en/about-us
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
    fr: '',
    es: '',
    pl: '',
  },
  company: {
    it: 'lazienda',
    en: 'the-company',
    fr: 'lentreprise',
    es: 'la-empresa',
    pl: 'firma',
  },
  products: {
    it: 'prodotti',
    en: 'products',
    fr: 'produits',
    es: 'productos',
    pl: 'produkty',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
    fr: 'contacts',
    es: 'contactos',
    pl: 'kontakt',
  },
  sustainability: {
    it: 'sostenibilita',
    en: 'sustainability',
    fr: 'durabilite',
    es: 'sostenibilidad',
    pl: 'zrownowazona-produkcja',
  },
  openDoors: {
    it: 'porte-aperte-in-bonifanti',
    en: 'open-doors',
    fr: 'portes-ouvertes',
    es: 'puertas-abiertas',
    pl: 'drzwi-otwarte',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
    fr: 'privacy',
    es: 'privacy',
    pl: 'privacy',
  },
  cookies: {
    it: 'cookie-policy',
    en: 'cookie-policy',
    fr: 'cookie-policy',
    es: 'cookie-policy',
    pl: 'cookie-policy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
